import { GroupCardAvatarContainer } from 'components/cards/styled'
import i18n from 'i18n'
import { GroupDoc, UserSettingsDoc } from 'types/api/changes'
import { Model } from 'types/model'
import { defaultGroupImage } from 'utils/api/groups'

import Avatar from './Avatar'
import * as Styled from './styled'
import { is24meApp } from 'utils/appType'
import { isGroupArchived, isGroupDeleted } from 'utils/api/userSettings'
import { isInIframe } from 'utils/env'
import { isGuest } from 'utils/user'

interface MultiAccountBadgeProps {
  className?: string
  images: string[]
  groups?: Model<GroupDoc>[]
  userSettings?: Model<UserSettingsDoc>
  groupIds?: string[]
}

export default function MultiAccountBadge(props: MultiAccountBadgeProps) {
  const dir = i18n.dir()

  let groupsForUI = [
    ...(props.groups?.filter(
      (group) =>
        !isGroupArchived(props.userSettings, group._id) &&
        !isGroupDeleted(props.userSettings, group._id)
    ) ?? [])
  ]

  if (props.groupIds) {
    groupsForUI = groupsForUI.filter((group) =>
      props.groupIds?.includes(group._id)
    )
  }

  const border = '3px'

  if (is24meApp()) return <></>

  const canShowUpToSix = isInIframe() || isGuest()
  const maxVisibleItems = canShowUpToSix ? 6 : 3
  const groupsToShow = groupsForUI.slice(0, maxVisibleItems)

  return (
    <Styled.MultiAccountBadge data-dir={dir} className={props.className}>
      {groupsToShow.map((group) => (
        <GroupCardAvatarContainer
          key={group._id}
          data-size="md"
          borderWidth={border}
          color={'white'}
        >
          <Avatar
            size={'md'}
            name=""
            asGroup
            img={group.Photo}
            emptyPic={defaultGroupImage(group)}
          />
        </GroupCardAvatarContainer>
      ))}
    </Styled.MultiAccountBadge>
  )
}
